var mixpanel = require('mixpanel-browser');

mixpanel.init("85f6151eea19a15b97635f0ec943c9ad");

export default mixpanel